//  SQL to generate this file - Set SQL query to text output CTRL + T in SQL Server Management Studio
//  (have to remove the leading // )

// SET NOCOUNT ON
// SELECT cast('
// /** '+ Name + ': ' + Description + ' */
// export const ' + MuellerGlobalData.dbo.Code_Char_GenerateFromName(Code) + ' = "' + Code + '"; ' as varchar(max))
// FROM MuellerGlobalData.dbo.FeatureSettings
// ORDER BY Code


/** Upgrade to 1004 Hybrid: Enable upgrade to 1004 Hybrid */
export const ACE_PDR_CONVERT_TO_APPRAISAL_1004_HYBRID = "ACE_PDR_CONVERT_TO_APPRAISAL_1004_HYBRID";

/** Upgrade to 70H: Enable upgrade to 70H */
export const ACE_PDR_CONVERT_TO_APPRAISAL_70H = "ACE_PDR_CONVERT_TO_APPRAISAL_70H";

/** Resend notifications on convert: Comma separated list of notification type codes to resend when converting to 70H */
export const ACE_PDR_CONVERT_TO_APPRAISAL_RESEND_NOTIFICATION = "ACE_PDR_CONVERT_TO_APPRAISAL_RESEND_NOTIFICATION";

/** Limit Appraisal Upgrade: Prevents Valuation Coordinators from upgrading to 70H appraisal before QA1 review completed */
export const ACE_PDR_LIMIT_APPRAISAL_UPGRADE = "ACE_PDR_LIMIT_APPRAISAL_UPGRADE";

/** Appraisal Case Survey Types: Comma delimited list of appraisal survey type codes eligible for broker e-mail */
export const APPRAISAL_CASE_SURVEY_TYPES = "APPRAISAL_CASE_SURVEY_TYPES";

/** Notification Type Code(s): Comma delimited notification type codes to mark. */
export const APPRAISAL_COMPLETED_RESEND_NOTIFICATION_CODES = "APPRAISAL_COMPLETED_RESEND_NOTIFICATION_CODES";

/** Appraisal Footer text: The custom footer text. */
export const APPRAISAL_PDF_FOOTER_TEXT_VALUE = "APPRAISAL_PDF_FOOTER_TEXT_VALUE";

/** Appraisal Header Image: The Resource name of the header image. */
export const APPRAISAL_PDF_HEADER_IMAGE_VALUE = "APPRAISAL_PDF_HEADER_IMAGE_VALUE";

/** Appraisal Logo Image: The Resource name of the logo image. */
export const APPRAISAL_PDF_LOGO_IMAGE_VALUE = "APPRAISAL_PDF_LOGO_IMAGE_VALUE";

/** Appraisal Company Name: The Custom Company Name for the appraisal. */
export const APPRAISAL_PDF_NAME_VALUE = "APPRAISAL_PDF_NAME_VALUE";

/** Appraisal QA Completed Event: Sends the Appraisal QA Completed event message */
export const APPRAISAL_PORT_MESSAGE_APPRAISAL_QA_COMPLETED = "APPRAISAL_PORT_MESSAGE_APPRAISAL_QA_COMPLETED";

/** Appraisal QA Revisions Completed Event: Sends the Appraisal QA Revisions Completed (QA reviews re-submittal) event message */
export const APPRAISAL_PORT_MESSAGE_APPRAISAL_QA_REVISIONS_COMPLETED = "APPRAISAL_PORT_MESSAGE_APPRAISAL_QA_REVISIONS_COMPLETED";

/** Appraisal QA Revisions Required Event: Sends the Appraisal QA Revisions Required (rejected to appraiser) event message */
export const APPRAISAL_PORT_MESSAGE_APPRAISAL_QA_REVISIONS_REQUIRED = "APPRAISAL_PORT_MESSAGE_APPRAISAL_QA_REVISIONS_REQUIRED";

/** Appraisal QA Started Event: Sends the Appraisal QA Started event message */
export const APPRAISAL_PORT_MESSAGE_APPRAISAL_QA_STARTED = "APPRAISAL_PORT_MESSAGE_APPRAISAL_QA_STARTED";

/** Inspection Completed Event: Sends the Inspection Completed event message */
export const APPRAISAL_PORT_MESSAGE_INSPECTION_COMPLETED = "APPRAISAL_PORT_MESSAGE_INSPECTION_COMPLETED";

/** Inspection Scheduled Event: Sends the Inspection Scheduled event message */
export const APPRAISAL_PORT_MESSAGE_INSPECTION_SCHEDULED = "APPRAISAL_PORT_MESSAGE_INSPECTION_SCHEDULED";

/** Inspector Appointment ETA (non-appraisal only): Sends the Inspector Appointment as the ETA on non-appraisal cases */
export const APPRAISAL_PORT_MESSAGE_INSPECTOR_APPOINTMENT_NONAPPRAISAL = "APPRAISAL_PORT_MESSAGE_INSPECTOR_APPOINTMENT_NONAPPRAISAL";

/** Inspector Assigned Event: Sends the Inspector Assigned event message */
export const APPRAISAL_PORT_MESSAGE_INSPECTOR_ASSIGNED = "APPRAISAL_PORT_MESSAGE_INSPECTOR_ASSIGNED";

/** Case Header Fields: Set which fields will display in the cover page case header. */
export const CASE_HEADER_FIELDS = "CASE_HEADER_FIELDS";

/** Download PDF: Set to True to save Risk Profiler PDF Report to case */
export const COLLATERAL_ANALYTICS_RISK_PROFILER_DOWNLOAD_PDF = "COLLATERAL_ANALYTICS_RISK_PROFILER_DOWNLOAD_PDF";

/** Ruleset Name: Name of ruleset to use */
export const COLLATERAL_ANALYTICS_RISK_PROFILER_RULESET_NAME = "COLLATERAL_ANALYTICS_RISK_PROFILER_RULESET_NAME";

/** CS Team Email: Email address for Customer Service. */
export const CS_TEAM_EMAIL_VALUE = "CS_TEAM_EMAIL_VALUE";

/** Days Inactive: Days a customer user account should be inactive before disabling */
export const DAYS_INACTIVE = "DAYS_INACTIVE";

/** Tiers: Tiers where demotion will be disabled */
export const DISABLE_DEMOTION_BY_TIER = "DISABLE_DEMOTION_BY_TIER";

/** Disable Mueller logo: Disables the Mueller logo that appears in each page's footer */
export const DISABLE_MUELLER_LOGO = "DISABLE_MUELLER_LOGO";

/** Edit RCT Depreciation: Allows editing of replacement cost depreciation multiplier */
export const EDIT_RCT_DEPRECIATION = "EDIT_RCT_DEPRECIATION";

/** Email to Policyholder when Complete: On Case Complete, the system will automatically send the PH report pdf to the policyholder (Case Contact Method of type E) */
export const EMAIL_PH_REPORT_PDF = "EMAIL_PH_REPORT_PDF";

/** Embed Inspection Report: Overrides the default logic embedding the inspection report in the appraisal PDF to always embed it. */
export const EMBED_INSPECTION_REPORT = "EMBED_INSPECTION_REPORT";

/** Enable custom cover image: Enables a custom image in the cover page just above the cover photo */
export const ENABLE_CUSTOM_COVER_IMAGE = "ENABLE_CUSTOM_COVER_IMAGE";

/** Export Policyholder Report PDF: Setting to indicate whether or not the PH PDF should be included with the PDF export */
export const EXPORT_PH_REPORT_PDF = "EXPORT_PH_REPORT_PDF";

/** Allow PCR Survey: Allow for sending the PCR survey type to FNMA */
export const FNMA_ALLOW_PCR_SURVEY = "FNMA_ALLOW_PCR_SURVEY";

/** Customer Decision Type: Can be one of the following: DecisionRequired, NoDecision, DecisionOnDataAndDoneOnly */
export const FNMA_CUSTOMER_DECISION_TYPE = "FNMA_CUSTOMER_DECISION_TYPE";

/** Fannie Mae Institution Id: The default institution id to send for UCDP and Waiver */
export const FNMA_INSTITUTION_ID = "FNMA_INSTITUTION_ID";

/** Minimum Date Entered: Minimum Date Entered on cases to export */
export const FNMA_MINIMUM_DATE_ENTERED = "FNMA_MINIMUM_DATE_ENTERED";

/** PDA Submitter Entity: Vendor ID for PDA Submitter Entity. Format should be "Mueller / {appraisal firm}" if Mueller is not performaing the appraisal */
export const FNMA_PDA_SUBMITTER_ENTITY = "FNMA_PDA_SUBMITTER_ENTITY";

/** Send If No Customer Decision: Send email even if no waiver decision is required */
export const FNMA_SEND_IF_NO_CUSTOMER_DECISION = "FNMA_SEND_IF_NO_CUSTOMER_DECISION";

/** Waiver Decision Email Address: Email addresses to send the waiver decision to. Use the word broker to indicate that the email gets sent to the broker. Separate multiple email addresses with a comma */
export const FNMA_WAIVER_DECISION_EMAIL_ADDRESS = "FNMA_WAIVER_DECISION_EMAIL_ADDRESS";

/** Include PCR PDF With Email: Attach the Property Condition Report PDF to the email */
export const FNMA_WAIVER_DECISION_EMAIL_INCLUDE_REPORT = "FNMA_WAIVER_DECISION_EMAIL_INCLUDE_REPORT";

/** Waiver Metrics Email Address: What email address(es) should the weekly / all time metrics report be sent to */
export const FNMA_WAIVER_METRICS_EMAIL_ADDRESS = "FNMA_WAIVER_METRICS_EMAIL_ADDRESS";

/** Enabled survey type codes: Survey type codes that should be exported to Fannie Mae */
export const FNMA_WAIVER_SURVEY_TYPE_CODES = "FNMA_WAIVER_SURVEY_TYPE_CODES";

/** Upgrade to Hybrid Required email address: Email address that the upgrade to hybrid email should be sent to */
export const FNMA_WAIVER_UPGRADE_TO_HYBRID_REQUIRED_EMAIL = "FNMA_WAIVER_UPGRADE_TO_HYBRID_REQUIRED_EMAIL";

/** Allow PCR Survey: Allow for sending the PCR survey type to FRE */
export const FRE_ALLOW_PCR_SURVEY = "FRE_ALLOW_PCR_SURVEY";

/** AMC Id: Freddie Mac assigned AMC ID */
export const FREDDIE_MAC_BACE_AMC_ID = "FREDDIE_MAC_BACE_AMC_ID";

/** Lender Id: Freddie Mac Assigned Lender Id */
export const FREDDIE_MAC_BACE_LENDER_ID = "FREDDIE_MAC_BACE_LENDER_ID";

/** Minimum Date Entered: Minimum Date Entered on cases to export */
export const FREDDIE_MAC_BACE_MINIMUM_DATE_ENTERED = "FREDDIE_MAC_BACE_MINIMUM_DATE_ENTERED";

/** Pilot ID: The pilot id sent to Freddie Mac BACE and MISMO in AppraiserFileIdentifier */
export const FREDDIE_MAC_BACE_PILOT_ID = "FREDDIE_MAC_BACE_PILOT_ID";

/** Enabled survey type codes: Survey type codes that should be exported to Freddie Mac */
export const FREDDIE_MAC_BACE_SURVEY_TYPE_CODES = "FREDDIE_MAC_BACE_SURVEY_TYPE_CODES";

/** Upgrade to Hybrid Required email address: Email address that the upgrade to hybrid email should be sent to */
export const FREDDIE_MAC_BACE_UPGRADE_TO_HYBRID_REQUIRED_EMAIL = "FREDDIE_MAC_BACE_UPGRADE_TO_HYBRID_REQUIRED_EMAIL";

/** The survey type codes to run submit on. Put a comma (,) between each code. If blank all eligible are assumed. Put "NO" in to turn off submit.: GAAR Submit Survey Type Codes */
export const GAAR_SUBMIT_SURVEY_TYPE_CODES = "GAAR_SUBMIT_SURVEY_TYPE_CODES";

/** Hide FLA PNX Value: The PNX data value that makes this condition true */
export const HIDE_FLA_PNX_VALUE = "HIDE_FLA_PNX_VALUE";

/** Hide FLA PNX Xpath: The PNX data xpath for the FLA condition value */
export const HIDE_FLA_PNX_XPATH = "HIDE_FLA_PNX_XPATH";

/** Deduct original survey type code base billing: Original survey type codes that should be deducted from the invoice amount when the current survey type is different than the original survey type */
export const INVOICE_PDF_ADJUST_BILLING_ORIGINAL_SURVEY_TYPE_CODE = "INVOICE_PDF_ADJUST_BILLING_ORIGINAL_SURVEY_TYPE_CODE";

/** Hazard Level: The hazard level that will be applied if out of range */
export const ITV_OUT_OF_RANGE_HAZARD_HAZARD_LEVEL = "ITV_OUT_OF_RANGE_HAZARD_HAZARD_LEVEL";

/** Maximum ITV: The upper bound of the ITV range */
export const ITV_OUT_OF_RANGE_HAZARD_MAX = "ITV_OUT_OF_RANGE_HAZARD_MAX";

/** Minimum ITV: The lower bound of the ITV range */
export const ITV_OUT_OF_RANGE_HAZARD_MIN = "ITV_OUT_OF_RANGE_HAZARD_MIN";

/** Next Day Business As Of: Start date of feature */
export const NEXT_DAY_BUSINESS_AS_OF_DATE_RECEIVED = "NEXT_DAY_BUSINESS_AS_OF_DATE_RECEIVED";

/** Next Day Business As Of: Start date of feature */
export const NEXT_DAY_BUSINESS_AS_OF_DUE_DATE = "NEXT_DAY_BUSINESS_AS_OF_DUE_DATE";

/** Non-Appraisal Case Survey Types: Comma delimited list of non-appraisal survey type codes eligible for broker e-mail */
export const NON_APPRAISAL_CASE_SURVEY_TYPES = "NON_APPRAISAL_CASE_SURVEY_TYPES";

/** Number of Photos Per Report Page: The number of photos to display per report pdf page */
export const NUM_PHOTOS_PER_PAGE = "NUM_PHOTOS_PER_PAGE";

/** Override At-Home Report Name: If an inspection was completed using M@H, override the report name with 'Virtual Inspection' */
export const OVERRIDE_AT_HOME_REPORT_NAME = "OVERRIDE_AT_HOME_REPORT_NAME";

/** PH Report Photo Tag List: Specifies a list of photo tags which when present on a photo cause the photo to be included in the policyholder report. */
export const PH_REPORT_PHOTO_TAG_LIST = "PH_REPORT_PHOTO_TAG_LIST";

/** Inspection Type Code List: List of inspection type codes to that should enable tagging in Phoenix Mobile */
export const PHOTO_GPS_TAGGING_ID_LIST = "PHOTO_GPS_TAGGING_ID_LIST";

/** Maximum Height: The maximum height in pixels */
export const PHOTO_RESOLUTION_MAXIMUM_HEIGHT = "PHOTO_RESOLUTION_MAXIMUM_HEIGHT";

/** Maximum Width: The maximum width in pixels */
export const PHOTO_RESOLUTION_MAXIMUM_WIDTH = "PHOTO_RESOLUTION_MAXIMUM_WIDTH";

/** Photo Tag Combine Token: The character used to separate combined photo tags */
export const PHOTO_TAG_COMBINE_TOKEN = "PHOTO_TAG_COMBINE_TOKEN";

/** Policy Holder Field Name: By default this is "Policy Holder"; appears on the cover page */
export const POLICY_HOLDER_FIELD_NAME = "POLICY_HOLDER_FIELD_NAME";

/** Policy Number Field Name: By default this is "Policy Number"; appears on the cover page and in headers */
export const POLICY_NUMBER_FIELD_NAME = "POLICY_NUMBER_FIELD_NAME";

/** Report Name: By default this is the survey type name; appears in the footers and cover page header */
export const REPORT_NAME = "REPORT_NAME";

/** Survey Type Code(s): Pipe delimited, leave blank for all surveys. */
export const SURVEY_TYPES = "SURVEY_TYPES";

/** UCDP Business Unit Number: UCDP Business Unit Number */
export const UCDP_BUSINESS_UNIT_NUMBER = "UCDP_BUSINESS_UNIT_NUMBER";

/** Fannie Mae Institution Id: The Fannie Mae Institution Id */
export const UCDP_FNM_INSTITUTION_ID = "UCDP_FNM_INSTITUTION_ID";

/** Fannie Mae Seller Number: The Fannie Mae Seller Number */
export const UCDP_FNM_SELLER_NUMBER = "UCDP_FNM_SELLER_NUMBER";

/** Freddie Mac Identification Number: The FRE Identification Number */
export const UCDP_FRE_IDENTIFICATION_NUMBER = "UCDP_FRE_IDENTIFICATION_NUMBER";

/** UCDP Preview Survey Type Codes: The survey type codes to run preview on. Put a comma (,) between each code. If Blank, it will turn off preview. */
export const UCDP_PREVIEW_SURVEY_TYPE_CODES = "UCDP_PREVIEW_SURVEY_TYPE_CODES";

/** UCDP Submit Survey Type Codes: The survey type codes to run submit on. Put a comma (,) between each code. If Blank, it will turn off submit. */
export const UCDP_SUBMIT_SURVEY_TYPE_CODES = "UCDP_SUBMIT_SURVEY_TYPE_CODES";

/** Value Verify: List of inspection types in FNMA Pilot program for Value Verify */
export const VALUE_VERIFY = "VALUE_VERIFY";
